import _styled from "@emotion/styled/base";
import { tokens } from '@datacamp/waffles/tokens';

var Label = _styled("span", {
  target: "ed34rxs0",
  label: "Label"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme === 'dark' ? tokens.colors.greyMedium : tokens.colors.navy,
    marginRight: 6
  };
}, "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zb2xlL0xhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRYyIsImZpbGUiOiIuLi8uLi9zcmMvY29uc29sZS9MYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB0b2tlbnMgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy90b2tlbnMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgdHlwZSB7IENvZGVFZGl0b3JUaGVtZSB9IGZyb20gJy4uL3R5cGVzJztcblxuZXhwb3J0IGludGVyZmFjZSBMYWJlbFByb3BzIHtcbiAgdGhlbWU6IENvZGVFZGl0b3JUaGVtZTtcbn1cbmNvbnN0IExhYmVsID0gc3R5bGVkLnNwYW48TGFiZWxQcm9wcz4oKHsgdGhlbWUgfSkgPT4ge1xuICByZXR1cm4ge1xuICAgIGNvbG9yOiB0aGVtZSA9PT0gJ2RhcmsnID8gdG9rZW5zLmNvbG9ycy5ncmV5TWVkaXVtIDogdG9rZW5zLmNvbG9ycy5uYXZ5LFxuICAgIG1hcmdpblJpZ2h0OiA2LFxuICB9O1xufSk7XG5cbmV4cG9ydCB7IExhYmVsIH07XG4iXX0= */");

export { Label };